import React from 'react';
import { scssVariables as variables } from 'src/helpers';

const primaryColor = variables['colors-mc-primary']; // #37d6c9
const primaryDark = variables['colors-mc-select-active']; // #288882

export const FileDCM = React.memo(() => (
  <>
    <defs>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='linear-gradient-dcm'
        x1='6.65'
        x2='27.27'
        y1='6.65'
        y2='27.27'
      >
        <stop offset='0' stopColor={primaryColor} />
        <stop offset='1' stopColor={primaryDark} />
      </linearGradient>
      <linearGradient
        id='linear-gradient-dcm-2'
        x1='6'
        x2='12'
        xlinkHref='#linear-gradient-dcm'
        y1='5'
        y2='5'
      />
    </defs>
    {/* File body */}
    <path
      fill={'url(#linear-gradient-dcm)'}
      d='M23.5,2h-12a.47.47,0,0,0-.35.15l-5,5A.47.47,0,0,0,6,7.5v20A2.5,2.5,0,0,0,8.5,30h15A2.5,2.5,0,0,0,26,27.5V4.5A2.5,2.5,0,0,0,23.5,2Z'
    />
    {/* Folded corner */}
    <path
      fill={'url(#linear-gradient-dcm-2)'}
      d='M11.69,2a.47.47,0,0,0-.54.11l-5,5A.47.47,0,0,0,6,7.69.5.5,0,0,0,6.5,8h3A2.5,2.5,0,0,0,12,5.5v-3A.5.5,0,0,0,11.69,2Z'
    />
    {/* Cross / plus symbol representing medical/DICOM */}
    <path
      fill={'#ffffff'}
      d='M17.5,12h-3a.5.5,0,0,0-.5.5v3h-3a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h3v3a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5v-3h3a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5h-3v-3A.5.5,0,0,0,17.5,12Z'
    />
  </>
));
FileDCM.displayName = 'FileDCM';
